import { useContext, useEffect, useMemo, useState } from "react";
import { config, fuelOption, packagesOption } from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";
import { AppContext, NavigatorContext } from "../../../../context";

export const useEditUsersCarList = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { commonPageSize } = config;
  const { getLoggedInUserData } = useService("User");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { showAlert, isBottom } = useService("Misc");
  const { isValidVehicleRegistrationNumber } = useService("Validation");
  const { urlToSplitData, getLocationData } = useService("Router");
  const { getCar, updateCar } = useService("Car");
  const user = getLoggedInUserData();
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [shoot360Url, setshoot360Url] = useState<string>("");
  const [shoot360, setshoot360] = useState<boolean>(false);
  const [registrationNo, setregistrationNo] = useState<string>("");
  const [registrationDate, setregistrationDate] = useState<string>("");
  const [chassisNo, setchassisNo] = useState<string>("");
  const [engineNo, setengineNo] = useState<string>("");
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [ownerName, setownerName] = useState(user.name);
  const [vehicleClass, setvehicleClass] = useState<string>("");
  const [activeFuelType, setactiveFuelType] = useState<number>(0);
  const [fuelType, setfuelType] = useState(fuelOption[0]);
  const [maker, setmaker] = useState<string>("");
  const [fitness, setfitness] = useState<string>("");
  const [mvTax, setmvTax] = useState<string>("");
  const [insurance, setinsurance] = useState<string>("");
  const [pucc, setpucc] = useState<string>("");
  const [emission, setemission] = useState<string>("");
  const [rcStatus, setrcStatus] = useState<string>("");
  const [financed, setfinanced] = useState<string>("");
  const [showForm, setshowForm] = useState<boolean>(false);
  const [carData, setcarData] = useState(null);
  const [uid, setuid] = useState<string>("");
  const [showInsurance, setshowInsurance] = useState<boolean>(true);
  const [showRc, setshowRc] = useState<boolean>(true);
  const [rcImage, setrcImage] = useState<string>("");
  const [insuranceImage, setinsuranceImage] = useState<string>("");
  const [filteredList, setfilteredList] = useState([]);

  setTitle(t("editUserCarsList"), "admin");
  const urlData = useMemo(
    () => urlToSplitData(getLocationData().pathname),
    [getLocationData, urlToSplitData]
  );
  useEffect(() => {
    getCarData({ uid: urlData[4] });
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getCarData = async (query) => {
    const result = await getCar(query);
    if (result.status) {
      let carData = result.data[0];
      if (typeof carData.rcImage === "undefined" || carData.rcImage === "") {
        setshowRc(false);
        carData.rcImage = "[]";
      }
      if (
        typeof carData.insuranceImage === "undefined" ||
        carData.insuranceImage === ""
      ) {
        setshowInsurance(false);
        carData.insuranceImage = "[]";
      }
      setmode("edit");
      setshoot360Url(carData.shoot360Url);
      setshoot360(carData.shoot360);
      setregistrationNo(carData.registrationNo);
      setregistrationDate(carData.registrationDate);
      setchassisNo(carData.chassisNo);
      setengineNo(carData.engineNo);
      setownerName(carData.ownerName);
      setvehicleClass(carData.vehicleClass);
      setmaker(carData.maker);
      setfitness(carData.fitness);
      setmvTax(carData.mvTax);
      setinsurance(carData.insurance);
      setpucc(carData.pucc);
      setfuelType(
        typeof carData.fuelType === "object"
          ? JSON.parse(carData.fuelType)
          : fuelOption[activeFuelType]
      );
      setemission(carData.emission);
      setrcStatus(carData.rcStatus);
      setfinanced(carData.financed);
      setcarData(JSON.parse(carData.carData));
      setuid(carData.uid);
      setshowForm(true);
      setrcImage(carData.rcImage);
      setinsuranceImage(carData.insuranceImage);
    }
  };

  const addCar = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      carObject = {
        shoot360Url: shoot360Url,
        shoot360: shoot360,
        registrationNo: registrationNo,
        registrationDate: registrationDate,
        chassisNo: chassisNo,
        engineNo: engineNo,
        ownerName: ownerName,
        vehicleClass: vehicleClass,
        maker: maker,
        fitness: fitness,
        mvTax: mvTax,
        insurance: insurance,
        pucc: pucc,
        fuelType: JSON.stringify(fuelType),
        emission: emission,
        rcImage: rcImage,
        insuranceImage: insuranceImage,
        rcStatus: rcStatus,
        financed: financed,
        carData: JSON.stringify(carData),
      };
    if (registrationNo === "") {
      errorMsg = t("errorMsg.required.vehicleRegistrationNumber");
      error = true;
    } else if (fuelType === "") {
      errorMsg = "Please select car fuel";
      error = true;
    } else if (!isValidVehicleRegistrationNumber(registrationNo)) {
      errorMsg = t("errorMsg.validate.vehicleRegistrationNumber");
      error = true;
    }
    if (!error) {
      let data = {
        query: JSON.stringify({ uid }),
        carData: JSON.stringify(carObject),
      };
      const result = await updateCar(data);
      if (result.status) {
        showAlert({ type: "success", msg: t("success.carUpdate") });
        navigateTo({ route: "/admin/car/list" });
      } else showAlert({ type: "error", msg: "Unable to update car!" });
    } else showAlert({ type: "error", msg: errorMsg });
  };
  return {
    trackScrolling,
    addCar,
    registrationNo,
    ownerName,
    vehicleClass,
    fuelType,
    maker,
    setshoot360,
    shoot360,
    shoot360Url,
    setshoot360Url,
    registrationDate,
    setregistrationDate,
    chassisNo,
    setchassisNo,
    engineNo,
    setengineNo,
    fitness,
    setfitness,
    mvTax,
    setmvTax,
    insurance,
    setinsurance,
    pucc,
    setpucc,
    emission,
    setemission,
    rcStatus,
    setrcStatus,
    financed,
    setfinanced,
  };
};
